import {SvgIcon, SvgIconProps} from "@mui/material";

export const RectangleTableIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <rect x="5" y="8" width="14" height="8" rx="1" fill="none"
              stroke="currentColor" strokeWidth="1.5"/>
        <circle cx="8" cy="4" r="2" fill="currentColor"/>
        <circle cx="16" cy="4" r="2" fill="currentColor"/>
        <circle cx="8" cy="20" r="2" fill="currentColor"/>
        <circle cx="16" cy="20" r="2" fill="currentColor"/>
    </SvgIcon>
);